module.exports = __webpack_public_path__ + "static/media/star-active.a7cb0e9d.svg";